import * as React from "react";
import { stories as ci, releases as Bn } from "./data/catalog.js";
export const AGE_GATE_LOGO = "/assets/logo-DJqoD9th.png";
export const FANSLY_ICON = "/assets/fnsl-CpnovntC.png";
export const REDDIT_ICON = "/assets/reddit-BXJr26zO.webp";
export const TWITTER_ICON = "/assets/twitter-DkUJXXd1.jpg";
export const LOCKED_IMAGE = "/assets/private-B5Q4vbT0.png";
export const ACCESS_STORAGE_KEY = "comic_full_access";
export const PASSWORD_STORAGE_KEY = "comic_reader_password";
export const COMIC_API = "/api/comic-page";
export const CACHE_LIMIT = 40;
export const PREFETCH_COUNT = 3;
export const PAGE_STEP = 10;
export const SITE_URL = "https://ekynoxe.art";
export const HOME_TITLE =
  "EKYNOXE comics | Free comic previews and online reader";
export const HOME_DESCRIPTION =
  "Read EKYNOXE comics online with free comic previews, full stories, latest chapter releases, and premium access on ekynoxe.art.";
export const pageCache = new Map();
export function touchCache(o, N) {
  (pageCache.delete(o), pageCache.set(o, N));
}
export function evictUnusedPages() {
  if (!(pageCache.size <= CACHE_LIMIT))
    for (const [o, N] of pageCache) {
      if (pageCache.size <= CACHE_LIMIT) return;
      N.refs > 0 || (pageCache.delete(o), URL.revokeObjectURL(N.url));
    }
}
export function hasCachedPage(o) {
  return pageCache.has(o);
}
export function retainCachedPage(o) {
  const N = pageCache.get(o);
  return N ? ((N.refs += 1), touchCache(o, N), N.url) : null;
}
export function cachePage(o, N, x = 1) {
  const r = pageCache.get(o);
  return r
    ? (r.url !== N && URL.revokeObjectURL(N),
      (r.refs += x),
      touchCache(o, r),
      r.url)
    : (pageCache.set(o, {
        url: N,
        refs: x,
      }),
      evictUnusedPages(),
      N);
}
export function releaseCachedPage(o, N) {
  if (!N) return;
  const x = pageCache.get(o);
  if (!x || x.url !== N) {
    URL.revokeObjectURL(N);
    return;
  }
  ((x.refs = Math.max(0, x.refs - 1)), pageCache.set(o, x), evictUnusedPages());
}
export function pageCacheKey(o, N) {
  return `${o}-${N}`;
}
export function clampPage(o, N) {
  return Math.min(Math.max(o, 1), N);
}
export function setMeta(o, N, x) {
  let r = document.head.querySelector(`meta[${o}="${N}"]`);
  (r ||
    ((r = document.createElement("meta")),
    r.setAttribute(o, N),
    document.head.appendChild(r)),
    r.setAttribute("content", x));
}
export function setCanonical(o) {
  let N = document.head.querySelector('link[rel="canonical"]');
  (N ||
    ((N = document.createElement("link")),
    N.setAttribute("rel", "canonical"),
    document.head.appendChild(N)),
    N.setAttribute("href", o));
}
export function useVisibility(o = "800px") {
  const N = React.useRef(null),
    [x, r] = React.useState(!1);
  return (
    React.useEffect(() => {
      if (x || typeof window > "u") return;
      const R = N.current;
      if (!R) return;
      if (!("IntersectionObserver" in window)) {
        r(!0);
        return;
      }
      const B = new IntersectionObserver(
        (w) => {
          const [te] = w;
          te?.isIntersecting && (r(!0), B.disconnect());
        },
        {
          rootMargin: o,
          threshold: 0.01,
        },
      );
      return (
        B.observe(R),
        () => {
          B.disconnect();
        }
      );
    }, [x, o]),
    {
      ref: N,
      isVisible: x,
    }
  );
}
export const chapterReleases = Bn.filter((o) => o.category !== "mini-story");
export const miniStories = Bn.filter((o) => o.category === "mini-story");
export const socialLinks = [
  {
    id: "fnsl",
    label: "Fansly",
    href: "https://fansly.com/EKYNOXE/posts",
    icon: FANSLY_ICON,
    description: "Full comics & website password",
  },
  {
    id: "reddit",
    label: "Reddit",
    href: "https://www.reddit.com/user/EKYNOXE/",
    icon: REDDIT_ICON,
    description: "Free teasers",
  },
  {
    id: "twitter",
    label: "Twitter / X",
    href: "https://x.com/ekynoxe_art",
    icon: TWITTER_ICON,
    description: "Updates & previews",
  },
];
export const storyReaders = ci.map((o) => ({
  id: o.id,
  name: o.name,
  pages: o.pages,
  thumbnail: o.thumbnail,
  freePages: o.freePages,
  releaseDate: o.status,
  isReleased: !0,
  publicSourceComicId: o.publicSourceComicId,
  paidSourceComicId: o.paidSourceComicId,
  chapters: o.chapters,
}));
export const longStoryIds = new Set(ci.map((o) => o.id));
export const allComics = [...storyReaders, ...Bn];
export function getFreePageCount(o) {
  return o.freePages == null
    ? null
    : Math.max(0, Math.min(o.freePages, o.pages));
}
export function resolveChapter(o, N) {
  if (!o.chapters) return null;
  let x = 1;
  for (const r of o.chapters) {
    if (N < x + r.pages)
      return {
        chapter: r,
        page: N - x + 1,
      };
    x += r.pages;
  }
  return null;
}
export function requiresProtectedSource(o, N) {
  const x = getFreePageCount(o);
  if (x == null || N <= x) return !1;
  const r = resolveChapter(o, N);
  return r ? r.page > r.chapter.publicPages : !0;
}
export function publicPageUrl(o, N) {
  const x = resolveChapter(o, N);
  return x
    ? `/comic/${x.chapter.comicId}/${x.page}.png`
    : `/comic/${o.publicSourceComicId ?? o.id}/${N}.png`;
}
export function protectedPageSource(o, N) {
  const x = resolveChapter(o, N);
  return x
    ? {
        comicId: x.chapter.comicId,
        page: x.page,
      }
    : {
        comicId: o.paidSourceComicId ?? o.id,
        page: N,
      };
}
export function lockedImageUrl() {
  return LOCKED_IMAGE;
}
export function padTime(o) {
  return String(o).padStart(2, "0");
}
export function releaseCountdown(o, N) {
  if (!o) return null;
  const x = Date.parse(o);
  if (Number.isNaN(x)) return null;
  const r = Math.max(0, x - N),
    R = Math.floor(r / 1e3),
    B = Math.floor(R / 3600),
    w = Math.floor((R % 3600) / 60),
    te = R % 60;
  return `${padTime(B)}h ${padTime(w)}m ${padTime(te)}s`;
}
export function isRecentRelease(o, N) {
  if (!o) return !1;
  const x = Date.parse(o);
  if (Number.isNaN(x)) return !1;
  const r = 5760 * 60 * 1e3;
  return N >= x && N - x < r;
}
export function getStoredPassword() {
  return typeof window > "u"
    ? null
    : window.localStorage.getItem(PASSWORD_STORAGE_KEY);
}
export function isPageLocked(o, N, x) {
  if (x) return !1;
  const r = getFreePageCount(o);
  return r == null || r >= o.pages ? !1 : N > r;
}
export function readRoute() {
  const o = new URLSearchParams(window.location.search),
    N = o.get("legal"),
    x = o.get("comic"),
    r = o.get("page"),
    R = o.get("mode"),
    B = R === "vertical" || R === "horizontal" ? R : "horizontal";
  if (N === "1")
    return {
      comicId: null,
      page: 1,
      orientation: B,
      activeView: "legal",
    };
  if (!x)
    return {
      comicId: null,
      page: 1,
      orientation: B,
      activeView: "home",
    };
  const w = allComics.find((L) => L.id === x);
  if (!w)
    return {
      comicId: null,
      page: 1,
      orientation: B,
      activeView: "home",
    };
  const te = Number.parseInt(r ?? "1", 10),
    _ = Number.isNaN(te) ? 1 : te,
    z = Math.min(Math.max(_, 1), w.pages);
  return {
    comicId: x,
    page: z,
    orientation: B,
    activeView: "reader",
  };
}
export function pushRoute(o) {
  const N = new URLSearchParams();
  (o.activeView === "legal"
    ? N.set("legal", "1")
    : o.comicId && (N.set("comic", o.comicId), N.set("page", String(o.page))),
    N.set("mode", o.orientation));
  const x = N.toString(),
    r = x ? `${window.location.pathname}?${x}` : window.location.pathname;
  window.history.pushState({}, "", r);
}
